import {
  LOAD_DRIVINGHOUR,
  LOAD_VEHICLE_DRIVINGHOUR,

} from "./actions";

const initialState = {
  drivinghourUrl: "",
  vehicleLists: [],
  drivinghourLoading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DRIVINGHOUR.REQUEST:
      const { loading } = action.payload;
      return {
        ...state,
        drivinghourLoading: loading
      };
    case LOAD_DRIVINGHOUR.SUCCESS:

      return {
        ...state,
        drivinghourUrl: action.payload.data.data,
        drivinghourLoading: false
      };
    case LOAD_VEHICLE_DRIVINGHOUR.SUCCESS:
      return {
        ...state,
        vehicleLists: action.payload.data.data,
        drivinghourLoading: false
        //  loading: false
      };
    default:
      return state;
  }
};
